export const isIconTagName = (value) => iconTagNames.includes(value);
export const iconTagNames = [
    'zui-icon-alerts-alarm-on',
    'zui-icon-alerts-ewi-check',
    'zui-icon-alerts-ewi-error-round',
    'zui-icon-alerts-ewi-error-triangle',
    'zui-icon-alerts-ewi-info',
    'zui-icon-alerts-ewi-question',
    'zui-icon-alerts-ewi-warning-round',
    'zui-icon-alerts-ewi-warning-triangle',
    'zui-icon-alerts-status-circle',
    'zui-icon-alerts-status-default',
    'zui-icon-alerts-status-triangle',
    'zui-icon-annotations-angle',
    'zui-icon-annotations-annotation-add',
    'zui-icon-annotations-annotation-off',
    'zui-icon-annotations-annotation-on',
    'zui-icon-annotations-annotation-popup',
    'zui-icon-annotations-annotation-scale-1',
    'zui-icon-annotations-annotation-scale-2',
    'zui-icon-annotations-annotation-settings',
    'zui-icon-annotations-arrow',
    'zui-icon-annotations-calipers',
    'zui-icon-annotations-circle-anchor-points',
    'zui-icon-annotations-disconnected-angle',
    'zui-icon-annotations-mode-freehand',
    'zui-icon-annotations-mode-pcb',
    'zui-icon-annotations-multi-calipers',
    'zui-icon-annotations-numbers',
    'zui-icon-annotations-polyline',
    'zui-icon-annotations-spline',
    'zui-icon-annotations-spline-contour',
    'zui-icon-arrows-above-threshold',
    'zui-icon-arrows-arrow-dropdown-alternative-down-s',
    'zui-icon-arrows-arrow-dropdown-alternative-down-xs',
    'zui-icon-arrows-arrow-dropdown-alternative-up-s',
    'zui-icon-arrows-arrow-dropdown-alternative-up-xs',
    'zui-icon-arrows-arrow-filled-double-down',
    'zui-icon-arrows-arrow-filled-double-up',
    'zui-icon-arrows-arrow-filled-down',
    'zui-icon-arrows-arrow-filled-hover-down',
    'zui-icon-arrows-arrow-filled-hover-up',
    'zui-icon-arrows-arrow-filled-left',
    'zui-icon-arrows-arrow-filled-right',
    'zui-icon-arrows-arrow-filled-up',
    'zui-icon-arrows-arrow-outline-actually-centred-down',
    'zui-icon-arrows-arrow-outline-actually-centred-left',
    'zui-icon-arrows-arrow-outline-actually-centred-right',
    'zui-icon-arrows-arrow-outline-actually-centred-up',
    'zui-icon-arrows-arrow-outline-visually-centered-down',
    'zui-icon-arrows-arrow-outline-visually-centered-left',
    'zui-icon-arrows-arrow-outline-visually-centered-right',
    'zui-icon-arrows-arrow-outline-visually-centered-up',
    'zui-icon-arrows-below-threshold',
    'zui-icon-arrows-link-left',
    'zui-icon-arrows-link-right',
    'zui-icon-arrows-shift-key',
    'zui-icon-common-100-percent',
    'zui-icon-common-3-d-box',
    'zui-icon-common-about',
    'zui-icon-common-action-not-done-yet',
    'zui-icon-common-analytics',
    'zui-icon-common-app-help',
    'zui-icon-common-arrange',
    'zui-icon-common-auto-number',
    'zui-icon-common-back',
    'zui-icon-common-battery-0-plain',
    'zui-icon-common-battery-100-colored',
    'zui-icon-common-battery-100-plain',
    'zui-icon-common-battery-20-colored',
    'zui-icon-common-battery-40-colored',
    'zui-icon-common-battery-60-colored',
    'zui-icon-common-battery-80-colored',
    'zui-icon-common-battery-charging-plain',
    'zui-icon-common-battery-speaker-off-colored',
    'zui-icon-common-battery-speaker-on-colored',
    'zui-icon-common-branch-history',
    'zui-icon-common-branch-new-track',
    'zui-icon-common-calculation',
    'zui-icon-common-calculator',
    'zui-icon-common-calibration',
    'zui-icon-common-cancel-event',
    'zui-icon-common-clinic',
    'zui-icon-common-close-fullscreen',
    'zui-icon-common-collisions',
    'zui-icon-common-compare-view-horizontal',
    'zui-icon-common-compare-view-horizontal-v-1',
    'zui-icon-common-compare-view-vertical',
    'zui-icon-common-compare-view-vertical-v-1',
    'zui-icon-common-cursor',
    'zui-icon-common-customer-support',
    'zui-icon-common-cut-move-down',
    'zui-icon-common-cut-move-up',
    'zui-icon-common-cut-scissors',
    'zui-icon-common-dark-mode',
    'zui-icon-common-dashboard',
    'zui-icon-common-delete',
    'zui-icon-common-delete-all',
    'zui-icon-common-delete-one-item',
    'zui-icon-common-diameter',
    'zui-icon-common-disconnected',
    'zui-icon-common-download',
    'zui-icon-common-drag-indicator',
    'zui-icon-common-duplicate',
    'zui-icon-common-edit-digital-filter-custom',
    'zui-icon-common-edit-edit',
    'zui-icon-common-edit-edit-copy',
    'zui-icon-common-edit-edit-protected',
    'zui-icon-common-edit-enter-data',
    'zui-icon-common-error',
    'zui-icon-common-exchange-add',
    'zui-icon-common-exchange-default',
    'zui-icon-common-expander',
    'zui-icon-common-expander-toolbox-closed',
    'zui-icon-common-expander-toolbox-opened',
    'zui-icon-common-explanatory-booklet',
    'zui-icon-common-export-default',
    'zui-icon-common-export-error',
    'zui-icon-common-export-success',
    'zui-icon-common-export-warning',
    'zui-icon-common-external-link',
    'zui-icon-common-file-stack',
    'zui-icon-common-filter',
    'zui-icon-common-filter-descending',
    'zui-icon-common-fit-to-extend',
    'zui-icon-common-fit-to-screen-size',
    'zui-icon-common-fit-to-view',
    'zui-icon-common-flip',
    'zui-icon-common-handle',
    'zui-icon-common-healthcheck',
    'zui-icon-common-hide',
    'zui-icon-common-histogram',
    'zui-icon-common-holy-placeholder',
    'zui-icon-common-home',
    'zui-icon-common-hotspot',
    'zui-icon-common-import-default',
    'zui-icon-common-import-error',
    'zui-icon-common-import-from-cloud',
    'zui-icon-common-import-warning',
    'zui-icon-common-incomplete',
    'zui-icon-common-infinity',
    'zui-icon-common-kpis',
    'zui-icon-common-language',
    'zui-icon-common-laser-point',
    'zui-icon-common-laser-beam',
    'zui-icon-common-laser-pointer-colored',
    'zui-icon-common-laser-pointer-plain',
    'zui-icon-common-laser-spot-size',
    'zui-icon-common-layer',
    'zui-icon-common-light-intensity',
    'zui-icon-common-light-off',
    'zui-icon-common-light-shutter-closed',
    'zui-icon-common-link-networks',
    'zui-icon-common-list',
    'zui-icon-common-lock-locked',
    'zui-icon-common-lock-open',
    'zui-icon-common-logout',
    'zui-icon-common-machine-logbook',
    'zui-icon-common-maximize',
    'zui-icon-common-measurments',
    'zui-icon-common-menu-capabilities',
    'zui-icon-common-menu-general-information',
    'zui-icon-common-menu-operating-data',
    'zui-icon-common-minimize',
    'zui-icon-common-more-bottom',
    'zui-icon-common-more-centered',
    'zui-icon-common-more-centered-caution',
    'zui-icon-common-more-centered-error',
    'zui-icon-common-more-centered-warning',
    'zui-icon-common-move-files',
    'zui-icon-common-move-general',
    'zui-icon-common-multi-select',
    'zui-icon-common-navigator',
    'zui-icon-common-none',
    'zui-icon-common-open-menue',
    'zui-icon-common-over-floater-menu',
    'zui-icon-common-panning-mode',
    'zui-icon-common-parameter',
    'zui-icon-common-pin',
    'zui-icon-common-print-add-on-success',
    'zui-icon-common-print-capture',
    'zui-icon-common-print-default',
    'zui-icon-common-print-screen',
    'zui-icon-common-probe',
    'zui-icon-common-procedure',
    'zui-icon-common-property-values',
    'zui-icon-common-qr-code',
    'zui-icon-common-redo',
    'zui-icon-common-refresh',
    'zui-icon-common-registered-trademark',
    'zui-icon-common-rename',
    'zui-icon-common-reset',
    'zui-icon-common-resize',
    'zui-icon-common-rotate',
    'zui-icon-common-rotate-180',
    'zui-icon-common-rotate-180-left',
    'zui-icon-common-rotate-90',
    'zui-icon-common-rotate-90-left',
    'zui-icon-common-rotate-left',
    'zui-icon-common-rulers-1-x',
    'zui-icon-common-rulers-2-x',
    'zui-icon-common-running',
    'zui-icon-common-running-plan',
    'zui-icon-common-save',
    'zui-icon-common-seal',
    'zui-icon-common-search-filter',
    'zui-icon-common-search-search',
    'zui-icon-common-selection-mode',
    'zui-icon-common-select-all',
    'zui-icon-common-select-from-list',
    'zui-icon-common-service',
    'zui-icon-common-settings-locked',
    'zui-icon-common-settings-settings',
    'zui-icon-common-settings-update',
    'zui-icon-common-share-default',
    'zui-icon-common-share-ios',
    'zui-icon-common-show',
    'zui-icon-common-shuttingdown',
    'zui-icon-common-signal-strength',
    'zui-icon-common-signal-strength-medium',
    'zui-icon-common-signal-strength-weak',
    'zui-icon-common-sort-date-ascending',
    'zui-icon-common-sort-date-descending',
    'zui-icon-common-sort-sort',
    'zui-icon-common-sort-sort-ascending',
    'zui-icon-common-sort-sort-az',
    'zui-icon-common-sort-sort-descending',
    'zui-icon-common-sort-sort-za',
    'zui-icon-common-split',
    'zui-icon-common-standby',
    'zui-icon-common-starting',
    'zui-icon-common-status-complete-circle',
    'zui-icon-common-status-complete-square',
    'zui-icon-common-status-incomplete-circle',
    'zui-icon-common-status-incomplete-square',
    'zui-icon-common-stopped',
    'zui-icon-common-stop',
    'zui-icon-common-sum',
    'zui-icon-common-tag',
    'zui-icon-common-temperature',
    'zui-icon-common-temperature-high',
    'zui-icon-common-temperature-low',
    'zui-icon-common-temperature-medium',
    'zui-icon-common-text-align-center',
    'zui-icon-common-text-align-left',
    'zui-icon-common-text-align-right',
    'zui-icon-common-text-bold',
    'zui-icon-common-text-italic',
    'zui-icon-common-text-list-bullet',
    'zui-icon-common-text-list-numbered',
    'zui-icon-common-text-text',
    'zui-icon-common-text-underline',
    'zui-icon-common-thumbtack',
    'zui-icon-common-ticket',
    'zui-icon-common-time-calendar',
    'zui-icon-common-time-date-calender',
    'zui-icon-common-time-date-carousel',
    'zui-icon-common-time-date-folder',
    'zui-icon-common-time-date-picker',
    'zui-icon-common-time-date-time',
    'zui-icon-common-time-not-date',
    'zui-icon-common-time-time',
    'zui-icon-common-time-today',
    'zui-icon-common-tree',
    'zui-icon-common-undo',
    'zui-icon-common-unknownstate',
    'zui-icon-common-unlink-networks',
    'zui-icon-common-unselect-all',
    'zui-icon-common-upload',
    'zui-icon-common-user-manual',
    'zui-icon-common-user-preferences',
    'zui-icon-common-voice-control',
    'zui-icon-common-voice-control-off',
    'zui-icon-common-voice-control-on',
    'zui-icon-common-watermark',
    'zui-icon-common-zone',
    'zui-icon-common-zoom-zoom-locked',
    'zui-icon-common-zoom-zoom-minus',
    'zui-icon-common-zoom-zoom-plus',
    'zui-icon-common-zoom-zoom-plus-minus',
    'zui-icon-communication-comment',
    'zui-icon-communication-mail',
    'zui-icon-communication-messages',
    'zui-icon-communication-phone',
    'zui-icon-communication-raise-hand',
    'zui-icon-communication-send-message',
    'zui-icon-communication-web',
    'zui-icon-files-file-add-file',
    'zui-icon-files-file-copy',
    'zui-icon-files-file-csv',
    'zui-icon-files-file-czamt',
    'zui-icon-files-file-czftp',
    'zui-icon-files-file-czi',
    'zui-icon-files-file-czrtj',
    'zui-icon-files-file-docx',
    'zui-icon-files-file-double-side',
    'zui-icon-files-file-file',
    'zui-icon-files-file-file-exported',
    'zui-icon-files-file-file-removed',
    'zui-icon-files-file-file-transfer',
    'zui-icon-files-file-file-unsupported',
    'zui-icon-files-file-jpg',
    'zui-icon-files-file-landscape',
    'zui-icon-files-file-log',
    'zui-icon-files-file-log-history',
    'zui-icon-files-file-one-side',
    'zui-icon-files-file-pdf',
    'zui-icon-files-file-png',
    'zui-icon-files-file-portrait',
    'zui-icon-files-file-report',
    'zui-icon-files-file-report-overview',
    'zui-icon-files-file-rtf',
    'zui-icon-files-file-select-file',
    'zui-icon-files-file-tiff',
    'zui-icon-files-file-xls',
    'zui-icon-files-folder-add-folder',
    'zui-icon-files-folder-back-to-parent',
    'zui-icon-files-folder-encrypted-folder',
    'zui-icon-files-folder-folder',
    'zui-icon-files-folder-move-to-folder',
    'zui-icon-files-folder-network-folder',
    'zui-icon-files-folder-open-in-explorer',
    'zui-icon-hardware-3-d-monitor',
    'zui-icon-hardware-4-k-quality',
    'zui-icon-hardware-connections-error',
    'zui-icon-hardware-connections-warning',
    'zui-icon-hardware-devices-2-d',
    'zui-icon-hardware-devices-3-d-ad-vision',
    'zui-icon-hardware-devices-4-k',
    'zui-icon-hardware-devices-connected',
    'zui-icon-hardware-devices-connected-warning',
    'zui-icon-hardware-devices-default',
    'zui-icon-hardware-devices-desktop',
    'zui-icon-hardware-devices-disconnected',
    'zui-icon-hardware-devices-embedded',
    'zui-icon-hardware-devices-hd',
    'zui-icon-hardware-devices-lq',
    'zui-icon-hardware-devices-notebook',
    'zui-icon-hardware-devices-sd',
    'zui-icon-hardware-devices-smartphone',
    'zui-icon-hardware-devices-splash-screen',
    'zui-icon-hardware-devices-tablet-portrait',
    'zui-icon-hardware-device-location',
    'zui-icon-hardware-hard-drive-default',
    'zui-icon-hardware-hard-drive-error',
    'zui-icon-hardware-hard-drive-warning',
    'zui-icon-hardware-high-quality',
    'zui-icon-hardware-long-term',
    'zui-icon-hardware-low-quality',
    'zui-icon-hardware-microscope-default',
    'zui-icon-hardware-microscope-disconnected',
    'zui-icon-hardware-microscope-settings',
    'zui-icon-hardware-mouse-left-button',
    'zui-icon-hardware-mouse-right-button',
    'zui-icon-hardware-mouse-wheel',
    'zui-icon-hardware-otg-disconnected',
    'zui-icon-hardware-server-server',
    'zui-icon-hardware-server-server-favorite-color',
    'zui-icon-hardware-server-server-favorite-plain',
    'zui-icon-hardware-server-server-list',
    'zui-icon-hardware-server-server-stored',
    'zui-icon-hardware-status-device',
    'zui-icon-hardware-status-device-error',
    'zui-icon-hardware-status-device-not-connected',
    'zui-icon-hardware-status-device-warning',
    'zui-icon-hardware-usb-error',
    'zui-icon-hardware-usb-horizontally',
    'zui-icon-hardware-usb-vertically',
    'zui-icon-hardware-usb-warning',
    'zui-icon-hardware-webcam',
    'zui-icon-image-aperture-default',
    'zui-icon-image-aperture-high',
    'zui-icon-image-aperture-low',
    'zui-icon-image-aperture-medium',
    'zui-icon-image-contrast',
    'zui-icon-image-crop-circle',
    'zui-icon-image-crop-default',
    'zui-icon-image-crop-rotate',
    'zui-icon-image-crop-square',
    'zui-icon-image-crop-triangle',
    'zui-icon-image-draw',
    'zui-icon-image-eraser',
    'zui-icon-image-eyedropper',
    'zui-icon-image-flip-horizontally',
    'zui-icon-image-flip-stack',
    'zui-icon-image-flip-vertically',
    'zui-icon-image-focus-progress',
    'zui-icon-image-gamma',
    'zui-icon-image-image-brightness-default',
    'zui-icon-image-image-brightness-full',
    'zui-icon-image-image-brightness-half',
    'zui-icon-image-image-brightness-quarter',
    'zui-icon-image-image-default',
    'zui-icon-image-image-error',
    'zui-icon-image-image-not-loaded',
    'zui-icon-image-image-process',
    'zui-icon-image-image-small',
    'zui-icon-image-magic-wand',
    'zui-icon-image-magic-wand-3',
    'zui-icon-image-no-image-image',
    'zui-icon-image-opacity',
    'zui-icon-image-overexposure',
    'zui-icon-image-overlay',
    'zui-icon-image-region-of-interest',
    'zui-icon-iqs-cmm',
    'zui-icon-iqs-connected-edges',
    'zui-icon-iqs-data-acquisition',
    'zui-icon-iqs-electrode',
    'zui-icon-iqs-feature-selection',
    'zui-icon-iqs-loop-selection',
    'zui-icon-iqs-mesh',
    'zui-icon-iqs-mirror',
    'zui-icon-iqs-product-family',
    'zui-icon-iqs-safety-shell-front',
    'zui-icon-iqs-safety-shell-side',
    'zui-icon-iqs-scanning',
    'zui-icon-iqs-shaft-length',
    'zui-icon-iqs-simulation',
    'zui-icon-iqs-single-edge',
    'zui-icon-iqs-smooth-edges',
    'zui-icon-iqs-sub-feature-selection',
    'zui-icon-iqs-u-v-reference-curves',
    'zui-icon-iqs-virtual-measuring-room',
    'zui-icon-iqs-volume',
    'zui-icon-iqs-wire-cut',
    'zui-icon-iqs-workpiece',
    'zui-icon-layout-grid-12-units',
    'zui-icon-layout-grid-1-unit',
    'zui-icon-layout-grid-4-columns',
    'zui-icon-layout-grid-4-units',
    'zui-icon-layout-grid-9-units',
    'zui-icon-layout-grid-mode',
    'zui-icon-layout-layout-1',
    'zui-icon-layout-layout-1-1',
    'zui-icon-layout-layout-1-1-1',
    'zui-icon-layout-layout-1-1-1-1',
    'zui-icon-layout-layout-1-1-2',
    'zui-icon-layout-layout-1-2',
    'zui-icon-layout-layout-1-3',
    'zui-icon-layout-layout-2-2',
    'zui-icon-layout-layout-3-3-3',
    'zui-icon-layout-layout-4-4-4-4',
    'zui-icon-layout-view-textual',
    'zui-icon-layout-view-thumbnail',
    'zui-icon-med-1-plus-4-map-overview',
    'zui-icon-med-2-maps-overview',
    'zui-icon-med-6-map-overview',
    'zui-icon-med-8-map-overview',
    'zui-icon-med-acquire-scan-mode-raster',
    'zui-icon-med-acquire-scan-mode-sector',
    'zui-icon-med-acquire-section-1-x',
    'zui-icon-med-acquire-section-2-x',
    'zui-icon-med-acquire-section-4-x',
    'zui-icon-med-advision',
    'zui-icon-med-alarm-high-alarm-default',
    'zui-icon-med-alarm-high-alarm-no-sound',
    'zui-icon-med-alarm-low-alarm-default',
    'zui-icon-med-alarm-low-alarm-no-sound',
    'zui-icon-med-alarm-medium-alarm-default',
    'zui-icon-med-alarm-medium-alarm-no-sound',
    'zui-icon-med-alarm-no-alarm-default',
    'zui-icon-med-alarm-no-alarm-no-sound',
    'zui-icon-med-alarm-subscription',
    'zui-icon-med-align-tip',
    'zui-icon-med-analyze-custom-maps-1',
    'zui-icon-med-analyze-custom-maps-4',
    'zui-icon-med-analyze-screens-compare',
    'zui-icon-med-analyze-screens-edit',
    'zui-icon-med-analyze-substract',
    'zui-icon-med-anterior',
    'zui-icon-med-area-measurement',
    'zui-icon-med-artevo-add-on-error',
    'zui-icon-med-artevo-add-on-warning',
    'zui-icon-med-artevo-default',
    'zui-icon-med-atlas-import',
    'zui-icon-med-blue-400-s',
    'zui-icon-med-centering-check',
    'zui-icon-med-centering-down',
    'zui-icon-med-centering-left',
    'zui-icon-med-centering-none',
    'zui-icon-med-centering-right',
    'zui-icon-med-centering-up',
    'zui-icon-med-center-tip',
    'zui-icon-med-chin-rest-movement',
    'zui-icon-med-cloud-services',
    'zui-icon-med-cloud-services-error',
    'zui-icon-med-cloud-services-warning',
    'zui-icon-med-cl-fitting-eye',
    'zui-icon-med-cl-fitting-keratoscopy-center',
    'zui-icon-med-cl-fitting-limbus',
    'zui-icon-med-cl-fitting-line-chart',
    'zui-icon-med-cl-fitting-pupil',
    'zui-icon-med-cl-fitting-pupil-center',
    'zui-icon-med-co-observer-1-d',
    'zui-icon-med-co-observer-2-d',
    'zui-icon-med-color-swatch',
    'zui-icon-med-connections',
    'zui-icon-med-connections-add-on-error',
    'zui-icon-med-connections-add-on-success',
    'zui-icon-med-connections-add-on-warning',
    'zui-icon-med-contact-glass-direct',
    'zui-icon-med-contact-glass-indirect',
    'zui-icon-med-corneal-topography',
    'zui-icon-med-data-migration',
    'zui-icon-med-dicom',
    'zui-icon-med-draw-arrow',
    'zui-icon-med-epithelial',
    'zui-icon-med-extaro-300',
    'zui-icon-med-extaro-300-add-on-error',
    'zui-icon-med-extaro-300-add-on-warning',
    'zui-icon-med-fcp-mode-1',
    'zui-icon-med-fcp-mode-2',
    'zui-icon-med-filter-ha-mode',
    'zui-icon-med-filter-retina-protect',
    'zui-icon-med-fluoresence',
    'zui-icon-med-focus-tip',
    'zui-icon-med-foot-pedal',
    'zui-icon-med-foot-pedal-add-on-error',
    'zui-icon-med-foot-pedal-add-on-warning',
    'zui-icon-med-foot-pedal-not-connected',
    'zui-icon-med-foot-trigger',
    'zui-icon-med-gauge-meter-default',
    'zui-icon-med-gauge-meter-default-add-on-warning',
    'zui-icon-med-gauge-meter-high',
    'zui-icon-med-gauge-meter-high-v-1',
    'zui-icon-med-gauge-meter-low',
    'zui-icon-med-gauge-meter-low-v-1',
    'zui-icon-med-gauge-meter-medium',
    'zui-icon-med-glasses',
    'zui-icon-med-glaucoma',
    'zui-icon-med-goniometer',
    'zui-icon-med-hand-grips-side-view',
    'zui-icon-med-hand-grips-top-view',
    'zui-icon-med-hand-trigger',
    'zui-icon-med-icrs',
    'zui-icon-med-imaging',
    'zui-icon-med-implant-axis',
    'zui-icon-med-interval',
    'zui-icon-med-intrabeam',
    'zui-icon-med-ioi',
    'zui-icon-med-iol-c-loop',
    'zui-icon-med-iol-implementation-time',
    'zui-icon-med-iol-loop',
    'zui-icon-med-iol-plate',
    'zui-icon-med-ir-800-default',
    'zui-icon-med-ir-800-flow-800',
    'zui-icon-med-joystick',
    'zui-icon-med-keratoconus',
    'zui-icon-med-keratoscopy',
    'zui-icon-med-keratoscopy-4-maps-sections',
    'zui-icon-med-keratoscopy-6-maps',
    'zui-icon-med-keratoscopy-cl-fitting',
    'zui-icon-med-keratoscopy-elevation',
    'zui-icon-med-keratoscopy-optical-quality-summary',
    'zui-icon-med-keratoscopy-summary',
    'zui-icon-med-keratoscopy-zernike-analysis',
    'zui-icon-med-kinevo-900',
    'zui-icon-med-kinevo-1-screen',
    'zui-icon-med-laser-add-subtract-dot',
    'zui-icon-med-laser-column',
    'zui-icon-med-laser-emission-plain',
    'zui-icon-med-laser-emission-triangle-red',
    'zui-icon-med-laser-emission-triangle-yellow',
    'zui-icon-med-laser-energy-density',
    'zui-icon-med-laser-guiding',
    'zui-icon-med-laser-pattern-circle-range',
    'zui-icon-med-laser-pattern-matrix',
    'zui-icon-med-laser-pattern-multiple-columns',
    'zui-icon-med-laser-pattern-single-column',
    'zui-icon-med-laser-ready',
    'zui-icon-med-laser-ready-plain',
    'zui-icon-med-laser-ready-yellow',
    'zui-icon-med-laser-spacing-btw-point',
    'zui-icon-med-laser-standby',
    'zui-icon-med-laterality-indicator',
    'zui-icon-med-lens-applanation',
    'zui-icon-med-lens-default',
    'zui-icon-med-lens-move',
    'zui-icon-med-lens-refer-to-center',
    'zui-icon-med-lens-single-use',
    'zui-icon-med-lens-tilt',
    'zui-icon-med-lens-visualization',
    'zui-icon-med-light-bulb-1',
    'zui-icon-med-light-bulb-2',
    'zui-icon-med-light-check',
    'zui-icon-med-light-meter-mode-average',
    'zui-icon-med-light-meter-mode-peak',
    'zui-icon-med-light-minus',
    'zui-icon-med-light-none',
    'zui-icon-med-light-plus',
    'zui-icon-med-lilt-check',
    'zui-icon-med-lilt-left',
    'zui-icon-med-lilt-left-right',
    'zui-icon-med-lilt-none',
    'zui-icon-med-lilt-right',
    'zui-icon-med-limbus',
    'zui-icon-med-lri',
    'zui-icon-med-lri-width',
    'zui-icon-med-lumera',
    'zui-icon-med-lumera-700-complete',
    'zui-icon-med-lumera-700-head',
    'zui-icon-med-lumera-belly',
    'zui-icon-med-lumera-caution',
    'zui-icon-med-lumera-error',
    'zui-icon-med-lumera-parking',
    'zui-icon-med-lumera-warning',
    'zui-icon-med-lumera-warning-s-3-s-4',
    'zui-icon-med-magnification-check',
    'zui-icon-med-magnification-minus',
    'zui-icon-med-magnification-none',
    'zui-icon-med-magnification-plus',
    'zui-icon-med-map-image',
    'zui-icon-med-meibography',
    'zui-icon-med-micor-mono',
    'zui-icon-med-microscope-head',
    'zui-icon-med-microscope-head-occular',
    'zui-icon-med-microscope-help',
    'zui-icon-med-microscope-kinevo-stand',
    'zui-icon-med-microscope-kinevo-stand-add-on-error',
    'zui-icon-med-microscope-kinevo-stand-add-on-warning',
    'zui-icon-med-microscope-stand',
    'zui-icon-med-microscope-stand-add-on-error',
    'zui-icon-med-microscope-stand-add-on-warning',
    'zui-icon-med-mode-microscope',
    'zui-icon-med-mode-point-lock',
    'zui-icon-med-mode-stand',
    'zui-icon-med-oct-auto-focus-af',
    'zui-icon-med-oct-auto-level-z',
    'zui-icon-med-oct-axis-xy',
    'zui-icon-med-oct-axis-x',
    'zui-icon-med-oct-axis-y',
    'zui-icon-med-oct-axis-z',
    'zui-icon-med-oct-brightness-contrast-minus-plus',
    'zui-icon-med-oct-brightness-contrast-plus-minus',
    'zui-icon-med-oct-calibration-tool',
    'zui-icon-med-oct-grid',
    'zui-icon-med-oct-noise-reduction-nr',
    'zui-icon-med-oct-position',
    'zui-icon-med-oct-rotation',
    'zui-icon-med-oct-rotation-x',
    'zui-icon-med-oct-rotation-y',
    'zui-icon-med-oct-scan-1-line',
    'zui-icon-med-oct-scan',
    'zui-icon-med-oct-scan-2-line',
    'zui-icon-med-oct-scan-5-line',
    'zui-icon-med-oct-scan-size',
    'zui-icon-med-oct-scan-size-duplicate',
    'zui-icon-med-oct-scan-size-x',
    'zui-icon-med-oct-scan-size-y',
    'zui-icon-med-oct-tracking-auto-z',
    'zui-icon-med-oculign',
    'zui-icon-med-opmi-focus',
    'zui-icon-med-opmi-zoom',
    'zui-icon-med-overlay-reference-matching',
    'zui-icon-med-pacs-connected',
    'zui-icon-med-parking-position',
    'zui-icon-med-phaco-add-on-error',
    'zui-icon-med-phaco-add-on-warning',
    'zui-icon-med-phaco-ia-time',
    'zui-icon-med-phaco-machine-default',
    'zui-icon-med-photometer-full',
    'zui-icon-med-photometer-limbus',
    'zui-icon-med-photometer-spot',
    'zui-icon-med-posterior',
    'zui-icon-med-power',
    'zui-icon-med-preparation',
    'zui-icon-med-procedure-time',
    'zui-icon-med-progress',
    'zui-icon-med-pulse',
    'zui-icon-med-pupillography',
    'zui-icon-med-qevo',
    'zui-icon-med-qevo-add-on-error',
    'zui-icon-med-qevo-not-connected',
    'zui-icon-med-qevo-rotation',
    'zui-icon-med-qevo-success',
    'zui-icon-med-qevo-warning',
    'zui-icon-med-quality-assurance',
    'zui-icon-med-radial-grid',
    'zui-icon-med-radioactivity',
    'zui-icon-med-reference-matching',
    'zui-icon-med-refer-to-corneal-vertex',
    'zui-icon-med-remote-access',
    'zui-icon-med-resight',
    'zui-icon-med-resight-lens-default',
    'zui-icon-med-resight-lens-single-use',
    'zui-icon-med-rhexis',
    'zui-icon-med-rhexis-overlay',
    'zui-icon-med-rhexis-time',
    'zui-icon-med-rock-switch',
    'zui-icon-med-rotating',
    'zui-icon-med-rulers-tear-meniscus-measurement',
    'zui-icon-med-sci-position-1',
    'zui-icon-med-sci-position-2',
    'zui-icon-med-sci-position-3',
    'zui-icon-med-search-devices',
    'zui-icon-med-sections',
    'zui-icon-med-slit-lamp',
    'zui-icon-med-slit-lamp-left',
    'zui-icon-med-slit-lamp-right',
    'zui-icon-med-steps-horizontal-colored',
    'zui-icon-med-steps-horizontal-grayscale',
    'zui-icon-med-steps-vertical-colored',
    'zui-icon-med-steps-vertical-grayscale',
    'zui-icon-med-sucction',
    'zui-icon-med-tear-analysis',
    'zui-icon-med-text-cursor',
    'zui-icon-med-tivato-700',
    'zui-icon-med-tivato-700-add-on-error',
    'zui-icon-med-tivato-700-add-on-warning',
    'zui-icon-med-total',
    'zui-icon-med-treatment-pack-size',
    'zui-icon-med-viewed',
    'zui-icon-med-warning-critical-triangle',
    'zui-icon-med-zones',
    'zui-icon-media-cam-cam-off',
    'zui-icon-media-cam-default',
    'zui-icon-media-cam-settings',
    'zui-icon-media-cam-switch-camera',
    'zui-icon-media-capture-button-edf',
    'zui-icon-media-capture-button-timelapse',
    'zui-icon-media-capture-capture',
    'zui-icon-media-capture-denoise',
    'zui-icon-media-capture-macro',
    'zui-icon-media-capture-option-fast-photo',
    'zui-icon-media-capture-screenshot',
    'zui-icon-media-microphone-off',
    'zui-icon-media-microphone-on',
    'zui-icon-media-play-pause',
    'zui-icon-media-play-play-filled',
    'zui-icon-media-play-play-outline',
    'zui-icon-media-repeat-loop-phase',
    'zui-icon-media-replay',
    'zui-icon-media-speaker-off',
    'zui-icon-media-speaker-on',
    'zui-icon-media-stop-outline',
    'zui-icon-media-stop-plain',
    'zui-icon-media-video-analog',
    'zui-icon-media-video-eject',
    'zui-icon-media-video-fast-forward',
    'zui-icon-media-video-jump-to-inpoint',
    'zui-icon-media-video-jump-to-next-phase',
    'zui-icon-media-video-jump-to-outpoint',
    'zui-icon-media-video-jump-to-previous-phase',
    'zui-icon-media-video-live-stream-off',
    'zui-icon-media-video-live-stream-on',
    'zui-icon-media-video-next-frame',
    'zui-icon-media-video-previous-frame',
    'zui-icon-media-video-record',
    'zui-icon-media-video-record-outline',
    'zui-icon-media-video-rewind',
    'zui-icon-media-video-set-inpoint',
    'zui-icon-media-video-set-outpoint',
    'zui-icon-media-video-video',
    'zui-icon-rms-3-d-box-coordinates',
    'zui-icon-rms-3-d-coordinates',
    'zui-icon-rms-3-d-view-from-x',
    'zui-icon-rms-3-d-view-from-y',
    'zui-icon-rms-3-d-view-from-z',
    'zui-icon-rms-acquisition-2-d-automatic',
    'zui-icon-rms-acquisition-2-d-multi-channel',
    'zui-icon-rms-acquisition-acquisition',
    'zui-icon-rms-acquisition-automated',
    'zui-icon-rms-acquisition-check-regions',
    'zui-icon-rms-acquisition-protocol',
    'zui-icon-rms-acquisition-topo',
    'zui-icon-rms-alignment-mode-horizontal',
    'zui-icon-rms-alignment-mode-vertical',
    'zui-icon-rms-artifacts',
    'zui-icon-rms-auto-lamella',
    'zui-icon-rms-beam-alignment',
    'zui-icon-rms-beam-off',
    'zui-icon-rms-beam-on',
    'zui-icon-rms-beam-orientation',
    'zui-icon-rms-bio-apps',
    'zui-icon-rms-camera-back-camera',
    'zui-icon-rms-cell-area',
    'zui-icon-rms-cell-counting',
    'zui-icon-rms-cell-counting-fast-snap',
    'zui-icon-rms-cell-counting-snap',
    'zui-icon-rms-classroom-manager',
    'zui-icon-rms-clipping-plane-x-y',
    'zui-icon-rms-clipping-plane-x-z',
    'zui-icon-rms-clipping-plane-y-z',
    'zui-icon-rms-crosshair-graticule',
    'zui-icon-rms-crosshair-large-circle-centre',
    'zui-icon-rms-crosshair-large-crossed-circle-centre',
    'zui-icon-rms-crosshair-no-crosshair',
    'zui-icon-rms-cross-section',
    'zui-icon-rms-cut-particle',
    'zui-icon-rms-detector-status',
    'zui-icon-rms-edf-active',
    'zui-icon-rms-edf-default',
    'zui-icon-rms-eds-acquisition-live',
    'zui-icon-rms-eds-analysis',
    'zui-icon-rms-eds-analysis-v-1',
    'zui-icon-rms-eds-mapping',
    'zui-icon-rms-edx-active',
    'zui-icon-rms-edx-default',
    'zui-icon-rms-extrapolation',
    'zui-icon-rms-false-color-off',
    'zui-icon-rms-false-color-on',
    'zui-icon-rms-fibres',
    'zui-icon-rms-field-of-view',
    'zui-icon-rms-focus',
    'zui-icon-rms-gis',
    'zui-icon-rms-grain-size-screen',
    'zui-icon-rms-group',
    'zui-icon-rms-guided-acquisition',
    'zui-icon-rms-height-measurement',
    'zui-icon-rms-histogram',
    'zui-icon-rms-image-processing',
    'zui-icon-rms-imaging-parameters',
    'zui-icon-rms-import-maps',
    'zui-icon-rms-intellesis-object-classification',
    'zui-icon-rms-lamella',
    'zui-icon-rms-lamella-lifting-out',
    'zui-icon-rms-lamella-showering',
    'zui-icon-rms-lamella-thinning-2nd-iteration',
    'zui-icon-rms-lamella-thinning-composite-shape-2nd-iteration',
    'zui-icon-rms-magnifier',
    'zui-icon-rms-manage-protocol',
    'zui-icon-rms-manual-online-stitching',
    'zui-icon-rms-measurments',
    'zui-icon-rms-merge-particles',
    'zui-icon-rms-metallic-shiny',
    'zui-icon-rms-micromanipulator-needle',
    'zui-icon-rms-multichannel',
    'zui-icon-rms-multichannel-view',
    'zui-icon-rms-multiphase',
    'zui-icon-rms-multiphase-screen',
    'zui-icon-rms-multi-site-creation',
    'zui-icon-rms-multi-site-processing',
    'zui-icon-rms-non-shiny',
    'zui-icon-rms-normalization-parameters',
    'zui-icon-rms-objective-objective-color',
    'zui-icon-rms-objective-objective-outlined',
    'zui-icon-rms-occupancy',
    'zui-icon-rms-oxides',
    'zui-icon-rms-particles-split',
    'zui-icon-rms-particles-table',
    'zui-icon-rms-particle-screen',
    'zui-icon-rms-paste',
    'zui-icon-rms-processing-batch-stitching',
    'zui-icon-rms-processing-image-tile-correction',
    'zui-icon-rms-processing-interactive-stitching',
    'zui-icon-rms-processing-list',
    'zui-icon-rms-processing-shapes',
    'zui-icon-rms-profile-line',
    'zui-icon-rms-protokoll-selection',
    'zui-icon-rms-range-slider',
    'zui-icon-rms-reduced-raster',
    'zui-icon-rms-reflector',
    'zui-icon-rms-regions-positions',
    'zui-icon-rms-region-grid',
    'zui-icon-rms-reshoot',
    'zui-icon-rms-ring-light-control',
    'zui-icon-rms-rotation-mode',
    'zui-icon-rms-sample-exchange',
    'zui-icon-rms-save-load-region',
    'zui-icon-rms-scan-ration',
    'zui-icon-rms-setup-manually',
    'zui-icon-rms-setup-qualification-measurement',
    'zui-icon-rms-setup-zen-connect',
    'zui-icon-rms-shading-correction',
    'zui-icon-rms-shearing-handle',
    'zui-icon-rms-simple-cross-section',
    'zui-icon-rms-size-distribution',
    'zui-icon-rms-special-table',
    'zui-icon-rms-spectrum-graphs-thumbnail',
    'zui-icon-rms-split-channel',
    'zui-icon-rms-split-image',
    'zui-icon-rms-stage-navigation',
    'zui-icon-rms-standard-specific-calculation',
    'zui-icon-rms-start-mapping',
    'zui-icon-rms-sulfides',
    'zui-icon-rms-system-parameters',
    'zui-icon-rms-table-processing',
    'zui-icon-rms-table-thumbnail',
    'zui-icon-rms-temprep',
    'zui-icon-rms-tensile-define-experiment',
    'zui-icon-rms-tensile-fit-and-fix',
    'zui-icon-rms-tensile-relax-sample',
    'zui-icon-rms-tensile-sample-experiment',
    'zui-icon-rms-tensile-sample-preparation',
    'zui-icon-rms-tensile-sample-results-view',
    'zui-icon-rms-thinned-lamella-composite',
    'zui-icon-rms-time-series',
    'zui-icon-rms-topography-acquisition',
    'zui-icon-rms-topography-calculation',
    'zui-icon-rms-transfer-image',
    'zui-icon-rms-u-cut',
    'zui-icon-rms-ungroup',
    'zui-icon-rms-view-microscope-centric',
    'zui-icon-rms-view-orbit',
    'zui-icon-rms-view-sample-centric',
    'zui-icon-rms-zen-connect-image-renderer',
    'zui-icon-rms-zen-connect-manual-alignment',
    'zui-icon-rms-zen-connect-project-details',
    'zui-icon-rms-zen-connect-video-renderer',
    'zui-icon-smt-cdu-tab',
    'zui-icon-smt-flare-tab',
    'zui-icon-smt-mirror',
    'zui-icon-smt-product-family',
    'zui-icon-symbols-checkmark',
    'zui-icon-symbols-checkmark-framed',
    'zui-icon-symbols-circle',
    'zui-icon-symbols-close',
    'zui-icon-symbols-close-framed',
    'zui-icon-symbols-crosshair-large',
    'zui-icon-symbols-crosshair-small',
    'zui-icon-symbols-crosshair-template',
    'zui-icon-symbols-custom-shape',
    'zui-icon-symbols-ellipse',
    'zui-icon-symbols-favorite-filled',
    'zui-icon-symbols-favorite-outlined',
    'zui-icon-symbols-freeform',
    'zui-icon-symbols-help',
    'zui-icon-symbols-info',
    'zui-icon-symbols-last-plan-sent',
    'zui-icon-symbols-line',
    'zui-icon-symbols-minus',
    'zui-icon-symbols-pillar',
    'zui-icon-symbols-plan-sent',
    'zui-icon-symbols-plus',
    'zui-icon-symbols-plus-framed',
    'zui-icon-symbols-polygon',
    'zui-icon-symbols-rectangle',
    'zui-icon-symbols-ring',
    'zui-icon-symbols-search-close',
    'zui-icon-symbols-site',
    'zui-icon-symbols-spot',
    'zui-icon-symbols-square',
    'zui-icon-symbols-trapezoid',
    'zui-icon-symbols-triangle-filled',
    'zui-icon-symbols-triangle-outlined',
    'zui-icon-user-sex-female',
    'zui-icon-user-sex-male',
    'zui-icon-user-sex-other',
    'zui-icon-user-sex-transgender',
    'zui-icon-user-sex-unknown',
    'zui-icon-user-user-add-group',
    'zui-icon-user-user-add-user',
    'zui-icon-user-user-add-user-framed',
    'zui-icon-user-user-best-practice-video',
    'zui-icon-user-user-duplicate-user',
    'zui-icon-user-user-edit-user',
    'zui-icon-user-user-import-patients',
    'zui-icon-user-user-import-user-framed',
    'zui-icon-user-user-my-videos',
    'zui-icon-user-user-operator',
    'zui-icon-user-user-settings-group',
    'zui-icon-user-user-surgery-profile',
    'zui-icon-user-user-switch-user',
    'zui-icon-user-user-user',
    'zui-icon-user-user-user-group',
    'zui-icon-user-user-user-user-details',
];
